import { makeAutoObservable } from 'mobx';

class IsSharePageStore {
    isSharePage = false;

    constructor() {
        makeAutoObservable(this);
    }

    setIsSharePage(value: boolean) {
        this.isSharePage = value;
    }
}

const isSharePageStore = new IsSharePageStore();
export default isSharePageStore;
